'use client'

import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { useTheme } from '@mui/material/styles'
import styles from './BreadcrumbItem.module.scss'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

// this component renders a breadcrumb item, and shows a menu on click

export const BreadcrumbItem = ({ breadcrumb, isLast }) => {
  const theme = useTheme()
  const ref = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const { openMainNavigationMenu, closeMainNavigationMenu, mainMenuItems } = useMenuItemsStore()
  const { sidebarMode } = useGlobalSettingsStore()

  const handleClick = (e) => {
    e.stopPropagation()
    const opening = !isOpen
    setIsOpen(opening)

    if (!opening) {
      closeMainNavigationMenu()
      return
    }

    const { offsetLeft } = ref.current || {}
    const sidebarOffset = sidebarMode === 'expanded' ? 264 : 64
    // debugger
    openMainNavigationMenu({
      rootKey: breadcrumb.urlSegment,
      offsetTop: 125,
      offsetLeft: sidebarOffset + offsetLeft,
      offsetWidth: 0,
      menuItems: breadcrumb.breadcrumbMenu
    })
  }

  useEffect(() => {
    if (!mainMenuItems) setIsOpen(false)
  }, [mainMenuItems])

  const hasMenu = breadcrumb.breadcrumbMenu

  return (
    <>
      <MUIStack
        data-testid="BreadcrumbItem"
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        className={[styles.breadcrumbItem, isOpen ? styles.open : '', isLast ? styles.last : '']}
        sx={{ cursor: hasMenu ? 'pointer' : 'default' }}
        ref={ref}
        onClick={hasMenu ? handleClick : null}
      >
        <MUITypography
          variant="body1"
          sx={{
            mr: hasMenu ? '4px' : '10px',
            mb: 0,
            color: 'text.secondary',
            maxWidth: '280px',
            cursor: hasMenu ? 'pointer' : 'default',
            userSelect: 'none'
          }}
          noWrap
        >
          {breadcrumb?.label}
        </MUITypography>
        {hasMenu ? (
          <ChevronRightIcon
            className={styles.breadcrumbChevron}
            sx={{ color: isLast ? 'white' : theme.palette.text.secondary }}
          />
        ) : null}
      </MUIStack>
    </>
  )
}

BreadcrumbItem.propTypes = {
  breadcrumb: PropTypes.object,
  isLast: PropTypes.bool
}
